import {getAPI} from '../privates/editorAPI'
import {Link} from '@wix/editor-platform-sdk-types'

export default function (appData) {
  /**
   * @doc editorUtils
   * @note `Classic Editor` `Editor X`
   * @param token - app token - not in use
   * @param options -
   *  - link: The Link object
   * @returns A promise with a string representation of the link object.
   */
  function getLinkAsString(token, options: {link: Link}): Promise<string> {
    return getAPI().then((api) => {
      return api.editor.utils.getLinkAsString(appData, token, options)
    })
  }

  /**
   * @doc editorUtils
   * @note `Classic Editor` `Editor X`
   * @description Retrieves a CSRF token used for API calls.
   * @example const csrfToken = await editorSDK.editor.utils.getCsrfToken(token);
   * @param token - app token - not in use
   * @returns A promise that is resolved with a CSRF token
   */
  async function getCsrfToken(token?: any): Promise<string> {
    const api = await getAPI()
    return api.editor.utils.getCsrfToken()
  }

  /**
   * @doc editorUtils
   * @note `Classic Editor` `Wix Studio`
   * @description Retrieves a platformized translation by key.
   * @example const translation = await editorSDK.editor.utils.translate('editor-sdk_css-per-breakpoint_banner_cascades');
   * @param key - The key of the translation
   * @returns A promise that is resolved with a translation string
   */
  async function translate(key: string): Promise<string> {
    const api = await getAPI()
    return api.editor.utils.translate(key)
  }

  /**
   * @doc editorUtils
   * @note `Classic Editor` `Wix Studio`
   * @description Retrieves platformized translations for multiple keys.
   * @example
   * const translations = await editorSDK.editor.utils.bulkTranslate([
   *   'editor-sdk_css-per-breakpoint_banner_cascades',
   *   'another-translation-key',
   * ]);
   * @param keys - An array of translation keys
   * @returns A promise that resolves with an array of translation strings in the same order as the input keys
   */
  async function bulkTranslate(keys: string[]): Promise<string[]> {
    const api = await getAPI()
    return api.editor.utils.translate(keys)
  }

  return {
    getLinkAsString,
    getCsrfToken,
    translate,
    bulkTranslate,
  }
}
